

<template>

  <div class="row"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

      <div class="content d-flex flex-column flex-column-fluid">
          <!-- Adaugă Factură Card -->
          <div class="container-fluid mb-12">
            <div class="card card-flush">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h3 class="card-title mb-0">{{ isEditMode ? 'Editează Factură' : 'Adaugă Factură' }}</h3>
                <button type="button" class="btn btn-sm btn-light-primary" @click="deschideModalFP">
                  Preia din FP
                </button>
              </div>
              <div class="card-body pt-0">
                <!-- Fallback visual confirmation for mounting -->
                <form onsubmit="return false;" id="formular_rapid" @keydown="handleFullArrowNavigation">
                  <div class="table-responsive">
                    <div class="row g-3 flex-wrap">
                      <div class="col-md-auto col-6">
                        <label class="form-label">Seria si nr. document</label>
                        <div class="input-group">
                          <input
                            id="id_serie"
                            v-model="factura.serie_document"
                            type="text"
                            class="form-control w-50"
                            placeholder="Serie"
                          />
                          <input v-model="factura.nr_document" type="text" class="form-control" placeholder="Nr.">
                        </div>
                      </div>
                      <!-- Furnizor -->
                      <div class="col-md-auto col-12">
                        <label class="form-label">Furnizor</label>
                        <div class="d-flex flex-wrap align-items-center gap-2">
                          <div style="flex-grow: 1; min-width: 200px; max-width: 400px;">
                            <multiselect
                              id="id_furnizor"
                              v-model="factura.furnizor_obj"
                              :options="lista_furnizori"
                              :custom-label="option => furnizorLabel(option)"
                              track-by="id"
                              placeholder="Furnizor"
                              class="form-control furnizor-multiselect"
                              :open-direction="'bottom'"
                              :select-label="''"
                              :deselect-label="''"
                              :selected-label="''"
                              @update:modelValue="val => {
                                factura.furnizor = val?.id || '';
                                factura.furnizor_obj = val || null;
                                incarcaSoldFurnizorSelected(val);
                              }"
                            >
                              <template #singleLabel="{ option }">
                                <span :title="furnizorLabel(option)">{{ furnizorLabel(option) }}</span>
                              </template>
                              <!-- Mesaj custom când nu există rezultate -->
                              <template #noResult="{ search }">
                                <div class="text-center p-2">
                                  <div class="text-muted mb-2">
                                    Furnizorul "<strong>{{ search }}</strong>" nu există.
                                  </div>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    @click="deschideFormAdaugareFurnizor(search)"
                                  >
                                    Adaugă furnizor
                                  </button>
                                </div>
                              </template>
                            </multiselect>
                          </div>
                          <button class="btn btn-sm btn-light" type="button" @click="modalNomenclatorFurnizori">
                            <i class="fas fa-list"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-auto col-6">
                        <label class="form-label">Data emitere</label>
                        <input v-model="factura.data_emitere" type="date" class="form-control" />
                      </div>
                      <div class="col-md-auto col-6">
                        <label class="form-label">Termen plata</label>
                        <input v-model="factura.termen_plata" type="date" class="form-control" />
                      </div>
                      <div class="col-md-auto col-6">
                        <label class="form-label">Sold</label>
                        <input :value="$filters.toCurrency(factura.sold)" type="text" class="form-control" disabled />
                      </div>
                    </div>
                  </div>
                  <!-- Responsive produse/servicii -->
                  <div class="table-responsive mt-5">
                    <div class="d-none d-md-block">
                      <!-- Header mimic on desktop -->
                      <div class="row fw-bold border-bottom pb-2 mb-2 gx-1">
                        <div class="col-auto" style="width: 50px; max-width: 50px; min-width: 50px;">#</div>
                        <div class="col-auto" style="width: 80px; max-width: 80px; min-width: 80px;">Tip</div>
                        <div class="col-auto" style="min-width: 300px; max-width: 300px; width: 300px;">Denumire articol / serviciu</div>
                        <div class="col-auto" style="min-width: 120px; max-width: 120px; width: 120px;">UM</div>
                        <div class="col-auto" style="width: 80px; max-width: 80px; min-width: 80px;">TVA%</div>
                        <div class="col-auto" style="width: 120px; max-width: 120px; min-width: 120px;">Cantitate</div>
                        <div class="col" style="min-width: 130px;">Preț unitar</div>
                        <div class="col" style="min-width: 130px;">Valoare</div>
                        <div class="col" style="min-width: 130px;">TVA</div>
                        <div class="col" style="min-width: 130px;">Total</div>
                        <div class="col-auto" style="min-width: 100px; max-width: 100px; width: 100px;">Cont credit</div>
                        <div class="col-auto" style="width: 46px; max-width: 46px; min-width: 46px;"></div>
                      </div>
                    </div>
                    <draggable v-model="facturaProduse" handle=".handle" item-key="pozitie" :clone="item => ({ ...item })">
                      <template #item="{ element: produs, index }"> 
                        <div class="row g-2 gx-1 align-items-center mb-3" :key="index">
                          <!-- Pozitie (drag handle) -->
                          <div class="col-auto" style="width: 50px; max-width: 50px; min-width: 50px;">
                            <label class="d-md-none form-label">Pozitie</label>
                            <div class="handle" style="cursor: move;">
                              {{ index + 1 }}
                            </div>
                          </div>
                            <!-- Tip -->
                            <div class="col-auto tip-col" style="width: 80px; max-width: 80px; min-width: 80px; padding-right: 0;">
                            <label class="d-md-none form-label">Tip</label>
                            <multiselect
                              :id="'tip_produse-' + produs.pozitie"
                              v-model="produs.tip_obj"
                              :options="tip_produse"
                              :custom-label="tipProduseLabel"
                              track-by="id"
                              placeholder="Tip"
                              class="form-control tip-produse-multiselect"
                              :open-direction="'bottom'"
                              :select-label="''"
                              :deselect-label="''"
                              :selected-label="''"
                              :allow-empty="false"
                              :show-clear="false"
                              @update:modelValue="val => { produs.tip = val?.id }"
                            >
                              <!-- când e închis: doar G / S -->
                              <template #singleLabel="{ option }">
                                <span :title="tipProduseLabel(option)">{{ option?.abreviere_tip_produs || '' }}</span>
                              </template>

                              <!-- în dropdown: G | Articole Generale -->
                              <template #option="{ option }">
                                <span class="tp-opt">
                                  <span class="tp-abbr">{{ option?.abreviere_tip_produs || '' }}</span>
                                  <span class="tp-sep">|</span>
                                  <span class="tp-text">{{ option?.text || '' }}</span>
                                </span>
                              </template>
                            </multiselect>
                            
                          </div>
                          <!-- Denumire articol / serviciu -->
                          <div class="col-auto text-truncate overflow-hidden denumire-col" style="min-width: 300px; max-width: 300px; width: 300px;">
                            <label class="form-label d-md-none">Denumire</label>
                            <div class="d-flex align-items-center gap-2 w-100">
                                <multiselect v-if="produs.tip == 1"
                                  :id="'produs-' + produs.pozitie"
                                  v-model="produs.denumire_obj"
                                  :options="lista_produse"
                                  :custom-label="option => option.text"
                                  :taggable="true"
                                  :allow-empty="false"
                                  :open-direction="'bottom'"
                                  placeholder="Denumire"
                                  @tag="newTag => {
                                    const newOption = { id: null, text: newTag };
                                    lista_produse.push(newOption);
                                    produs.denumire_obj = newOption;
                                    produs.denumire = newOption.text;
                                    adaugaRandProdusDacaETGol();
                                  }"
                                  @update:modelValue="val => {
                                    produs.denumire = val?.text || '';
                                    produs.denumire_obj = val;
                                    adaugaRandProdusDacaETGol();
                                  }"
                                  class="form-control multiselect-custom"
                                >
                                  <template #singleLabel="{ option }">
                                    <span :title="option?.text || ''">{{ option?.text || '' }}</span>
                                  </template>
                                </multiselect>
                              <template v-if="produs.tip == 2">
                                <multiselect v-if="produs.tip == 2"
                                  :id="'produs-' + produs.pozitie"
                                  v-model="produs.denumire_obj"
                                  :options="lista_produse_stoc"
                                  :custom-label="option => option.text"
                                  :allow-empty="false"
                                  :open-direction="'bottom'"
                                  placeholder="Denumire"
                                  @update:modelValue="val => {
                                    produs.denumire = val?.text || '';
                                    produs.denumire_obj = val;
                                    adaugaRandProdusDacaETGol();
                                  }"
                                  class="form-control multiselect-denumire"
                                >
                                  <template #singleLabel="{ option }">
                                    <span :title="option?.text || ''">{{ option?.text || '' }}</span>
                                  </template>
                                </multiselect>
                                <button
                                  class="btn btn-sm btn-icon btn-light-primary"
                                  @click="deschideNomenclatorProduseStoc()">
                                  <i class="fas fa-list"></i>
                                </button>
                              </template>
                            </div>
                          </div>
                          <!-- UM -->
                          <div class="col-auto" style="min-width: 120px; max-width: 120px; width: 120px;">
                            <label class="d-md-none form-label">UM</label>
                            <multiselect
                              :id="'um-' + produs.pozitie"
                              v-model="produs.um_obj"
                              :options="unitati_masura"
                              :custom-label="option => option?.text || ''"
                              track-by="id"
                              placeholder="UM"
                              :select-label="''"
                              :deselect-label="''"
                              :selected-label="''"
                              class="multiselect-custom"
                              style="width: 120px;"
                              :open-direction="'bottom'"
                              @update:modelValue="val => {
                                produs.um = (val && val.id !== undefined && val.id !== null) ? Number(val.id) : '';
                                produs.um_obj = val || null;
                              }"
                            >
                              <template #singleLabel="{ option }">
                                {{ (option?.text || '').split(' (')[0] }}
                              </template>
                            </multiselect>
                          </div>
                          <div class="col-auto" style="width: 80px; max-width: 80px; min-width: 80px;">
                            <label class="d-md-none form-label">TVA %</label>
                            <multiselect
                              :id="'tva-' + produs.pozitie"
                              v-model="produs.cota_tva_obj"
                              :options="cote_tva"
                              track-by="id"
                              :custom-label="opt => (opt && opt.cota_tva !== undefined && opt.cota_tva !== null) ? (opt.cota_tva + '%') : ''"
                              placeholder="TVA%"
                              :allow-empty="false"
                              :searchable="false"
                              :select-label="''"
                              :deselect-label="''"
                              :selected-label="''"
                              class="multiselect-custom"
                              style="width: 80px;"
                              :open-direction="'bottom'"
                              @update:modelValue="val => {
                                produs.cota_tva = (val && val.cota_tva !== undefined && val.cota_tva !== null) ? Number(val.cota_tva) : 0;
                                produs.cota_tva_obj = val || null;
                                updateCalculations(produs);
                              }"
                            >
                              <template #singleLabel="{ option }">
                                <span>{{ option?.cota_tva }}%</span>
                              </template>
                            </multiselect>
                          </div>
                          <!-- Cantitate -->
                          <div class="col-auto" style="width: 120px; max-width: 120px; min-width: 120px;">
                            <label class="d-md-none form-label">Cantitate</label>
                            <input v-model="produs.cantitate" @input="updateCalcul(index, 'cantitate')" type="number" class="form-control" placeholder="Cantitate" />
                          </div>
                          <!-- Pret unitar -->
                          <div class="col" style="min-width: 130px;">
                            <label class="d-md-none form-label">Preț unitar</label>
                            <input v-model="produs.pret" @input="updateCalcul(index, 'pret')" type="number" class="form-control" placeholder="Preț unitar" />
                          </div>
                          <!-- Valoare -->
                          <div class="col" style="min-width: 130px;">
                            <label class="d-md-none form-label">Valoare</label>
                            <input v-model="produs.valoare" @input="updateCalcul(index, 'valoare')" type="text" class="form-control" placeholder="Valoare" />
                          </div>
                          <!-- TVA -->
                          <div class="col" style="min-width: 130px;">
                            <label class="d-md-none form-label">TVA</label>
                            <input type="text" :value="produs.valoare_tva" @input="updateCalculations(produs)" class="form-control" placeholder="TVA" readonly />
                          </div>
                          <!-- Total -->
                          <div class="col" style="min-width: 130px;">
                            <label class="d-md-none form-label">Total</label>
                            <input type="text" v-model="produs.total" @input="updateFromTotal(index)" class="form-control" placeholder="Total" />
                          </div>
                          <!-- Cont credit -->
                          <div class="col-auto" style="min-width: 100px; max-width: 100px; width: 100px;">
                            <label class="d-md-none form-label">Cont credit</label>
                            <multiselect
                              :id="'cont_credit-' + produs.pozitie"
                              v-model="produs.cont_credit_obj"
                              :options="plan_conturi"
                              track-by="id"
                              :custom-label="pcLabel"
                              placeholder="Cont credit"
                              class="multiselect-custom multiselect-left ms-pc"
                              :searchable="true"
                              :internal-search="true"
                              :select-label="''"
                              :deselect-label="''"
                              :selected-label="''"
                              @open="onPCOpenQueued(produs)"
                              @close="onPCClose(produs)"
                              @update:modelValue="val => {
                                produs.cont_credit = val?.cod_complet || '';
                                produs.cont_credit_obj = val || null;
                              }"
                            >
                              <template #singleLabel="{ option }">
                                <span>{{ option?.cod_complet || '' }}</span>
                              </template>
                              <template #option="{ option }">
                                <span class="pc-opt">
                                  <span class="pc-cod">{{ option?.cod_complet || '' }}</span>
                                  <span class="pc-sep">|</span>
                                  <span class="pc-den">{{ option?.descriere || '' }}</span>
                                </span>
                              </template>
                            </multiselect>
                          </div>
                          <!-- Reset linie (nu sterge randul) -->
                          <div class="col-auto" style="width: 46px; max-width: 46px; min-width: 46px;">
                            <label class="d-md-none form-label">Șterge</label>
                            <button
                              type="button"
                              class="btn btn-sm btn-icon btn-light-danger"
                              :title="'Resetează linia #' + (index + 1)"
                              @click="resetProdusLine(index)"
                            >
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>
                      </template>
                    </draggable>
                  </div>
                </form>
                <!-- Toggle button for extra info sections and Adaugă/Renunță buttons, all on one row -->
                <div class="mt-10 d-flex align-items-center flex-wrap gap-3">
                  <button class="btn btn-secondary" type="button" @click="afiseazaInformatii = !afiseazaInformatii" >
                    {{ afiseazaInformatii ? 'Ascunde mai multe informații' : 'Afișează mai multe informații' }}
                  </button>
                  <div class="d-flex gap-3 ms-auto">
                    <button type="button" class="btn btn-light" @click="$emit('renuntaFactura')">Renunță</button>
                    <button type="button" class="btn btn-primary" @click="adaugaFactura()">
                      {{ isEditMode ? 'Modifică' : 'Adaugă' }}
                    </button>
                  </div>
                </div>
                <!-- Extra info sections, shown only if afiseazaInformatii -->
                <div v-if="afiseazaInformatii">
                  <div class="mt-10">
                    <div class="row">
                      <!-- Stânga: Informații suplimentare (textbox) -->
                      <div class="col-md-6">
                        <h4 class="mb-3">Informații suplimentare</h4>
                        <textarea
                          v-model="factura.informatii_suplimentare"
                          class="form-control"
                          rows="5"
                          placeholder="Adaugă informații adiționale aici..."
                        ></textarea>
                      </div>
                      <!-- Dreapta: Descarcarea de gestiune (radio) -->
                      <div class="col-md-6">
                        <h4 class="mb-3">Descarcarea de gestiune</h4>
                        <div class="form-check mb-2">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="informatie_suplimentara"
                            id="opt1"
                            value="1"
                            v-model="factura.descarcare_gestiune"
                            checked
                          />
                          <label class="form-check-label" for="opt1">
                            Descarcarea de gestiune se face la salvarea acestui document. <br />
                            Livrarea produselor se face în baza acestui document.
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="informatie_suplimentara"
                            id="opt2"
                            value="2"
                            v-model="factura.descarcare_gestiune"
                          />
                          <label class="form-check-label" for="opt2">
                            Descarcarea de gestiune se face pe baza Avizului de Însoțire. <br />
                            Livrarea produselor se face pe baza Avizului de Însoțire a Mărfurilor.
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- New row of fields below Descarcarea de gestiune -->
                  <div class="mt-10">
                    <div class="row">
                      <div class="col-md-2 mb-3">
                        <label class="form-label">Delegat</label>
                        <input v-model="factura.delegat_nume" type="text" class="form-control" />
                      </div>
                      <div class="col-md-2 mb-3">
                        <label class="form-label">CNP/Buletin delegat</label>
                        <input v-model="factura.delegat_date" type="text" class="form-control" />
                      </div>
                      <div class="col-md-2 mb-3">
                        <label class="form-label">Auto</label>
                        <input v-model="factura.delegat_auto" type="text" class="form-control" />
                      </div>
                      <div class="col-md-2 mb-3">
                        <label class="form-label">Curs Valutar</label>
                        <div class="input-group">
                          <Select2
                            id="valuta"
                            v-model="factura.valuta"
                            :options="valute"
                            :settings="setari_select2"
                            @select="onSelectValuta"
                          />
                          <input
                            v-model="factura.curs_valutar"
                            type="number"
                            step="0.0001"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-2 mb-3">
                        <label class="form-label">Întocmit de</label>
                        <input v-model="factura.intocmit_de" type="text" class="form-control" />
                      </div>
                      <div class="col-md-2 mb-3">
                        <label class="form-label">CNP</label>
                        <input v-model="factura.intocmit_cnp" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Metronic-styled switch to toggle Tabel Facturare -->
          <div class="container-fluid mb-6">
            <div class="form-check form-switch form-check-custom form-check-solid">
              <input class="form-check-input" type="checkbox" id="switch_afiseaza_lista" v-model="modelAfiseazaLista"/>
              <label class="form-check-label ms-3" for="switch_afiseaza_lista">
                  Afișează Lista Facturi primite
              </label>
            </div>
          </div>
      </div>

  </div>


    <!-- Modal furnizor -->
    <div class="modal fade" id="FurnizorModal" role="dialog" aria-labelledby="FurnizorModalLabel">
      <div class="modal-dialog" style="max-width: 95vw; margin: 1rem auto;">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="FurnizorModalLabel">Nomenclator Furnizori</h3>
            <!--begin::Close-->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <!--end::Close-->
          </div>
          <div class="modal-body">
            <div v-if="showFormAdaugareFurnizor" class="p-4 border-bottom">
              <div class="row g-3">
                <!-- Row 1 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Denumire</label>
                    <input v-model="form_modal_furnizori.f_denumire" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele complet al furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CUI</label>
                    <div class="input-group">
                      <input
                        v-model="form_modal_furnizori.c_cui"
                        type="text"
                        class="form-control"
                        placeholder="Introduceți CUI"
                      />
                      <button
                        class="btn btn-sm btn-icon btn-light-primary"
                        type="button"
                        @click="verificaCUI(form_modal_furnizori.c_cui)"
                      >
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                    <div class="text-muted fs-7">Codul unic de identificare fiscală.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Reg. Com.</label>
                    <input v-model="form_modal_furnizori.c_reg_com" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul de înregistrare la registrul comerțului.</div>
                  </div>
                </div>
                <!-- Row 2 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Localitate</label>
                    <input v-model="form_modal_furnizori.c_localitate" type="text" class="form-control" />
                    <div class="text-muted fs-7">Localitatea sediului furnizorului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Telefon</label>
                    <input v-model="form_modal_furnizori.c_telefon" type="text" class="form-control" />
                    <div class="text-muted fs-7">Număr de contact al furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Email</label>
                    <input v-model="form_modal_furnizori.c_email" type="email" class="form-control" />
                    <div class="text-muted fs-7">Adresă de email validă pentru contact.</div>
                  </div>
                </div>
                <!-- Strada -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Strada</label>
                    <input v-model="form_modal_furnizori.c_strada" type="text" class="form-control" />
                    <div class="text-muted fs-7">Strada sediului furnizorului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <!-- Cod poștal -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cod poștal</label>
                    <input v-model="form_modal_furnizori.c_cod_postal" type="text" class="form-control" />
                    <div class="text-muted fs-7">Codul poștal al sediului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <!-- Row 3 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Adresă</label>
                    <input v-model="form_modal_furnizori.c_adresa" type="text" class="form-control" />
                    <div class="text-muted fs-7">Adresă completă a sediului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Județ</label>
                    <input v-model="form_modal_furnizori.c_judet" type="text" class="form-control" />
                    <div class="text-muted fs-7">Județul în care se află furnizorul. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Țara</label>
                    <input v-model="form_modal_furnizori.c_tara" type="text" class="form-control" />
                    <div class="text-muted fs-7">Țara de rezidență a furnizorului.</div>
                  </div>
                </div>
                <!-- Row 4 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Banca</label>
                    <input v-model="form_modal_furnizori.c_banca" type="text" class="form-control" />
                    <div class="text-muted fs-7">Instituția bancară a furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cont bancar</label>
                    <input v-model="form_modal_furnizori.c_cont_banca" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul contului bancar.</div>
                  </div>
                </div>
                <!-- Row 5 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Persoană de contact</label>
                    <input v-model="form_modal_furnizori.c_pers_contact" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele persoanei de contact.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele delegatului care livrează produsele.</div>
                  </div>
                </div>
                <!-- Row 6 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CNP Delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat_cnp" type="text" class="form-control" />
                    <div class="text-muted fs-7">Cod numeric personal al delegatului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Serie CI</label>
                    <input v-model="form_modal_furnizori.c_ci_serie" type="text" class="form-control" />
                    <div class="text-muted fs-7">Serie carte de identitate.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Număr CI</label>
                    <input v-model="form_modal_furnizori.c_ci_nr" type="text" class="form-control" />
                    <div class="text-muted fs-7">Număr carte de identitate.</div>
                  </div>
                </div>
                <!-- Row 7 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CI eliberat de</label>
                    <input v-model="form_modal_furnizori.c_ci_eliberat" type="text" class="form-control" />
                    <div class="text-muted fs-7">Instituția care a eliberat CI-ul.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Auto delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat_auto" type="text" class="form-control" />
                    <div class="text-muted fs-7">Autovehicul folosit de delegat.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cod agent</label>
                    <input v-model="form_modal_furnizori.c_cod_agent" type="text" class="form-control" />
                    <div class="text-muted fs-7">Cod intern al agentului.</div>
                  </div>
                </div>
                <!-- Row 8 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Zile scadență</label>
                    <input v-model="form_modal_furnizori.c_scadenta" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul de zile până la scadență.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Discount</label>
                    <input v-model="form_modal_furnizori.c_discount" type="text" class="form-control" />
                    <div class="text-muted fs-7">Reducere acordată în %.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Atrib. fiscal</label>
                    <input v-model="form_modal_furnizori.c_atrib_fiscal" type="text" class="form-control" />
                    <div class="text-muted fs-7">Atribuția fiscală a furnizorului.</div>
                  </div>
                </div>
                <!-- Row 9 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">SCP TVA</label>
                    <input v-model="form_modal_furnizori.c_scp_tva" type="text" class="form-control" />
                    <div class="text-muted fs-7">Sistemul de plată al TVA-ului.</div>
                  </div>
                </div>
                <div class="col-12 text-end">
                  <button class="btn btn-sm btn-success" @click="adaugaFurnizor()" v-if="!editmode">Adaugă furnizorul</button>
                  <button class="btn btn-sm btn-success" @click="actualizeazaFurnizor(form_modal_furnizori.c_id)" v-if="editmode">Actualizează furnizorul</button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm btn-primary" @click="showFormAdaugareFurnizor = !showFormAdaugareFurnizor">
              {{ showFormAdaugareFurnizor ? 'Anulează' : 'Adauga furnizor' }}
            </button>
            <table id="tabel_furnizori" class="table table-bordered table-striped table-hover align-middle">
              <thead class="table-light fw-bold">
                <tr>
                    <th class="min-w-30px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="ID Furnizor: apasa pentru sortare crescatoare">ID</th>
                    <th class="min-w-150px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Denumire: apasa pentru sortare crescatoare">Denumire</th>
                    <th class="min-w-50px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Cui: apasa pentru sortare crescatoare">CUI</th>
                    <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Registru Comertului: apasa pentru sortare crescatoare">Reg.Com</th>
                    <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Localitate: apasa pentru sortare crescatoare">Localitate</th>
                    <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Zile scadenta: apasa pentru sortare crescatoare">Zile scadenta</th>
                    <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Reducere acordata: apasa pentru sortare crescatoare">Reducere acordata</th>
                    <th class="min-w-70px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Email: apasa pentru sortare crescatoare">Email</th>
                    <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Telefon: apasa pentru sortare crescatoare">Telefon</th>
                    <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Persoana de contact: apasa pentru sortare crescatoare">Persoana de contact</th>
                    <th class="min-w-20px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Actiuni</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dc in detalii_furnizori" :key="dc.id">
                  <td>{{ dc.c_id || '' }}</td>
                  <td>{{ dc.c_denumire || '' }}</td>
                  <td>{{ dc.c_cui || '' }}</td>
                  <td>{{ dc.c_reg_com || '' }}</td>
                  <td>{{ dc.c_localitate || '' }}</td>
                  <td>{{ dc.c_scadenta || '' }}</td>
                  <td>{{ dc.c_discount || '' }}</td>
                  <td>{{ dc.c_email || '' }}</td>
                  <td>{{ dc.c_telefon || '' }}</td>
                  <td>{{ dc.c_pers_contact || '' }}</td>
                  <td>
                    <div class="d-flex flex-column flex-md-row gap-2">
                      <button class="btn btn-sm btn-warning" @click="editareFurnizorFormFill(dc)">Modifică</button>
                      <button class="btn btn-sm btn-danger" @click="stergeFurnizor(dc.c_id)">Șterge</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Proforme (Preia din FP) -->
    <div class="modal fade" id="ModalProforme" tabindex="-1" role="dialog" aria-labelledby="ModalProformeLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalProformeLabel">Proforme nefacturate</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th style="width: 80px;">ID</th>
                    <th>Nr. doc</th>
                    <th>Data</th>
                    <th>Furnizor</th>
                    <th class="text-end">Total</th>
                    <th style="width: 120px;">Acțiuni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="proforme.length === 0">
                    <td colspan="6" class="text-center text-muted py-5">Nu există proforme disponibile.</td>
                  </tr>
                  <tr v-for="pf in proforme" :key="pf.id">
                    <td>{{ pf.id }}</td>
                    <td>{{ pf.nr_doc }}</td>
                    <td>{{ pf.data_doc }}</td>
                    <td>{{ pf.furnizor_denumire }}</td>
                    <td class="text-end">{{ $filters.toCurrency(pf.total) }}</td>
                    <td class="d-flex gap-2 actions">
                      <!-- Buton Precompletare -->
                      <button type="button" class="btn btn-sm btn-light-primary flex-fill" :disabled="pf._loading" @click="selecteazaProforma(pf)">
                        <span v-if="pf._loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>{{ pf._loading ? 'Se încarcă…' : 'Select' }}</span>
                      </button>

                      <!-- Buton Creează instant -->
                      <button type="button" class="btn btn-sm btn-success flex-fill" :disabled="pf._creating" @click="creeazaFacturaInstant(pf)">
                        <span v-if="pf._creating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>{{ pf._creating ? 'Se creează…' : 'Creează acum' }}</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Închide</button>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
    
    import moment from "moment";
    import draggable from 'vuedraggable';
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    
    
    export default {
        props: {
          afiseazaLista: Boolean,
          editMode: { type: Boolean, default: false },
          facturaEdit: { type: Object, default: null },
        },
        emits: ['update:afiseazaLista', 'renuntaFactura', 'facturaSaved'],
        components: {
            moment: moment,
            draggable,
            Multiselect,
        },
        computed: {
          isEditMode() {
            return !!this.editMode;
          },
        },
        watch: {
          // cand primim o factura pentru editare din lista
          facturaEdit: {
            immediate: true,
            handler() {
              this.queueHydrateEdit();
            }
          },
          // cand comutam in/din edit mode
          editMode() {
            this.queueHydrateEdit();
          },
          // cand se incarca listele async, re-hidratam ca sa prinda obiectele corecte
          lista_furnizori() {
            this.queueHydrateEdit();
          },
          tip_produse() {
            this.queueHydrateEdit();
          },
          unitati_masura() {
            this.queueHydrateEdit();
          }
        },
    data () {
      return {
        setari_select2: {
            theme: 'bootstrap-5',
            placeholder: "Selectează din listă",
            width: "100%",
        },
        setari_select2_produse: {
            theme: 'bootstrap-5',
            tags: true,
            width: "100%",
        },
        setari_select2_serie: {
            theme: 'bootstrap-5',
            placeholder: "Seria",
            width: "100%",
        },
        setari_select2_um: {
            theme: 'bootstrap-5',
            placeholder: "Selectează din listă",
            width: "100%",
        },
        furnizori: [],
        lista_furnizori: [],
        detalii_furnizori: [],
        serii_facturi: [],
        unitati_masura: [],
        tip_produse: [],
        lista_produse: [],
        lista_produse_stoc: [],
        valute: [],
        editmode: false,
        facturi_emise: [],
        afiseazaInformatii: false,
        plan_conturi: [],
        cote_tva: [],
        factura: Form.make({
            id: '',
            // pentru facturi de intrare lucrăm logic cu furnizor
            furnizor: '',
            furnizor_obj: '',
            serie_document: '',
            serie_document_obj: '',
            nr_document: '',
            data_emitere: new Date().toISOString().split('T')[0],
            termen_plata: new Date().toISOString().split('T')[0],
            sold: '',
            efactura: 'Neplătită',
            descarcare_gestiune: '1', // salvare(1) / aviz(2) 
            informatii_suplimentare: '', // nou
            delegat_nume: '',
            delegat_date: '',
            delegat_auto: '',
            valuta: 1,
            curs_valutar: '',
            intocmit_de: '',
            intocmit_cnp: '',
        }),
        showFormAdaugareFurnizor: false,
        form_modal_furnizori: Form.make({
            c_id: '',
            c_cut: '',
            f_denumire: '',
            c_cui: '',
            c_reg_com: '',
            c_localitate: '',
            c_strada: '',
            c_cod_postal: '',
            c_adresa: '',
            c_judet: '',
            c_tara: '',
            c_banca: '',
            c_cont_banca: '',
            c_email: '',
            c_telefon: '',
            c_pers_contact: '',
            c_delegat: '',
            c_delegat_cnp: '',
            c_ci_serie: '',
            c_ci_nr: '',
            c_ci_eliberat: '',
            c_delegat_auto: '',
            c_cod_agent: '',
            c_scadenta: '',
            c_discount: '',
            c_atrib_fiscal: '',
            c_scp_tva: '',
        }),
        facturaProduse: [
          {
            pozitie: 1,
            tip: '1',
            tip_obj: '',
            denumire: '',
            denumire_obj: '',
            um: '',
            um_obj: '',
            cota_tva: '21',
            cota_tva_obj: null,
            cantitate: '',
            pret: '',
            valoare: '',
            valoare_tva: '',
            total: '',
            cont_credit: '',
            cont_credit_obj: null,
          }
        ],
        proforme: [],
        id_proforma_selectata: null,
        _hydratingEdit: false,
        _hydratingEditTimer: null,
      }
    },

    methods: {
      tipProduseLabel(option) {
        if (!option) return '';
        const abbr = (option.abreviere_tip_produs ?? '').toString().trim();
        const txt  = (option.text ?? '').toString().trim();
        // label complet ca să poți căuta și după G/S și după text
        return [abbr, txt].filter(Boolean).join(' | ');
      },
      incarcaCoteTVA() {
        axios.get('/api/facturare/utils/incarcaCoteTVA')
          .then(res => {
            const rd = (res && res.data !== undefined) ? res.data : [];
            const arr = Array.isArray(rd)
              ? rd
              : (Array.isArray(rd.data) ? rd.data : (Array.isArray(rd.cote_tva) ? rd.cote_tva : []));

            this.cote_tva = (arr || []).map(x => ({
              ...x,
              cota_tva: (x && x.cota_tva !== undefined && x.cota_tva !== null) ? Number(x.cota_tva) : x?.cota_tva,
            }));

            this.queueHydrateEdit();
            // force default TVA = 21% on first empty row when form opens
            this.$nextTick(() => {
            if (Array.isArray(this.facturaProduse) && this.facturaProduse.length > 0) {
              const p0 = this.facturaProduse[0];
              // If first row already has a TVA value (ex: '21') but object ref is missing, resolve it from options.
              // If it's missing/empty, force the default 21%.
              if (!p0.cota_tva_obj) {
                const tvaNum = (p0.cota_tva !== '' && p0.cota_tva !== null && p0.cota_tva !== undefined)
                  ? Number(p0.cota_tva)
                  : null;

                if (tvaNum !== null && !Number.isNaN(tvaNum) && Array.isArray(this.cote_tva)) {
                  // resolve object reference for existing TVA
                  p0.cota_tva = tvaNum;
                  p0.cota_tva_obj = this.cote_tva.find(ct => Number(ct.cota_tva) === tvaNum) || null;
                }

                if (!p0.cota_tva_obj) {
                  // fallback: force default TVA (21%) and set object if available
                  const def = this.getDefaultCotaTVA();
                  p0.cota_tva = def.value;
                  p0.cota_tva_obj = def.obj;
                }
              }
            }
            });
          })
          .catch(() => {
            this.cote_tva = [];
          });
      },
      getDefaultCotaTVA() {
        if (!Array.isArray(this.cote_tva) || this.cote_tva.length === 0) {
          return { value: 21, obj: null };
        }

        const found21 = this.cote_tva.find(ct => Number(ct.cota_tva) === 21);
        if (found21) {
          return { value: 21, obj: found21 };
        }

        const sorted = [...this.cote_tva]
          .map(x => ({ ...x, cota_tva: Number(x?.cota_tva) }))
          .filter(x => !Number.isNaN(x.cota_tva))
          .sort((a, b) => a.cota_tva - b.cota_tva);

        const first = sorted[0] || this.cote_tva[0] || null;
        return first
          ? { value: Number(first.cota_tva), obj: first }
          : { value: 21, obj: null };
      },
      queueHydrateEdit() {
        // debounce scurt ca sa nu ruleze de 10 ori in aceeasi secunda (cand vin si listele async)
        try {
          if (this._hydratingEditTimer) clearTimeout(this._hydratingEditTimer);
        } catch (e) {}

        this._hydratingEditTimer = setTimeout(() => {
          this.hydrateEditFlow();
        }, 50);
      },
      incarcaPC() {
        axios.get('/api/facturare/utils/incarcaPC')
          .then(res => {
            const rd = (res && res.data !== undefined) ? res.data : [];
            // accepta mai multe formate posibile: array direct sau obiect cu data/plan_conturi
            const arr = Array.isArray(rd)
              ? rd
              : (Array.isArray(rd.data) ? rd.data : (Array.isArray(rd.plan_conturi) ? rd.plan_conturi : []));

            this.plan_conturi = arr;
          })
          .catch(() => {
            this.plan_conturi = [];
          });
      },
      pcLabel(option) {
        if (!option) return '';
        const cod = (option.cod_complet ?? option.cod ?? option.cont ?? option.code ?? '').toString();
        const den = (option.descriere ?? option.denumire ?? option.nume ?? option.name ?? '').toString();
        // IMPORTANT: search-ul intern (internal-search) se bazeaza pe string-ul returnat aici
        return `${cod} | ${den}`.trim();
      },
      pcDesiredWidthPx(rootWidth = 0) {
        // dropdown ~ cât câmpul + un pic, dar NU full screen
        return Math.min(520, Math.max(340, (rootWidth || 0) + 220));
      },
      onPCOpenQueued(produs) {
        // In template, globals like `window` are resolved via _ctx (and can be undefined).
        // So we queue inside the component method where the global is available.
        const raf = (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function')
          ? window.requestAnimationFrame
          : (fn) => setTimeout(fn, 0);

        raf(() => this.onPCOpen(produs));
      },
      onPCOpen(produs) {
        this.$nextTick(() => {
          try {
            const id = produs && produs.pozitie ? `cont_credit-${produs.pozitie}` : null;
            if (!id) return;

            // id-ul la vue-multiselect ajunge de obicei pe input-ul intern (sau uneori pe root)
            const el = document.getElementById(id);
            if (!el) return;

            const root = el.classList && el.classList.contains('multiselect')
              ? el
              : el.closest('.multiselect');
            if (!root) return;

            const wrapper = root.querySelector('.multiselect__content-wrapper');
            if (!wrapper) return;

            // reset
            wrapper.classList.remove('pc-open-left');
            wrapper.style.left = '';
            wrapper.style.right = '';
            wrapper.style.minWidth = '';
            wrapper.style.maxWidth = '';
            wrapper.style.width = '';
            wrapper.style.maxHeight = '';
            wrapper.style.overflowY = '';

            const rect = root.getBoundingClientRect();

            // Target width: like the largest input field (but clamped)
            const desired = this.pcDesiredWidthPx(rect.width || 0);
            const minW = 340;
            const maxW = 520;
            const width = Math.min(maxW, Math.max(minW, desired));

            // Decide direction (auto left/right) based on available space
            const spaceRight = Math.max(0, window.innerWidth - rect.left - 10);
            const spaceLeft = Math.max(0, rect.right - 10);

            let openLeft = false;
            if (width > spaceRight && spaceLeft >= width) {
              openLeft = true;
            } else if (width <= spaceRight) {
              openLeft = false;
            } else {
              openLeft = spaceLeft > spaceRight;
            }

            wrapper.style.width = `${width}px`;
            wrapper.style.minWidth = `${width}px`;
            wrapper.style.maxWidth = `${maxW}px`;

            if (openLeft) {
              wrapper.classList.add('pc-open-left');
              wrapper.style.left = 'auto';
              wrapper.style.right = '0px';
            } else {
              wrapper.classList.remove('pc-open-left');
              wrapper.style.left = '0px';
              wrapper.style.right = 'auto';
            }

            // Height (excel-like): compact with scroll
            wrapper.style.maxHeight = '320px';
            wrapper.style.overflowY = 'auto';
          } catch (e) {}
        });
      },
      onPCClose(produs) {
        this.$nextTick(() => {
          try {
            const id = produs && produs.pozitie ? `cont_credit-${produs.pozitie}` : null;
            if (!id) return;

            const inputEl = document.getElementById(id);
            if (!inputEl) return;

            const root = inputEl.closest('.multiselect');
            if (!root) return;

            const wrapper = root.querySelector('.multiselect__content-wrapper');
            if (!wrapper) return;

            // lasa animatia de close sa ruleze fara sa-i schimbi anchor-ul (altfel "sare" dreapta)
            const RESET_AFTER_MS = 180;

            setTimeout(() => {
              try {
                wrapper.classList.remove('pc-open-left');
                wrapper.style.left = '';
                wrapper.style.right = '';
                wrapper.style.minWidth = '';
                wrapper.style.maxWidth = '';
                wrapper.style.width = '';
                wrapper.style.maxHeight = '';
                wrapper.style.overflowY = '';
              } catch (e) {}
            }, RESET_AFTER_MS);
          } catch (e) {}
        });
      },
      async fetchProduseIntrareForEdit(facturaId) {
        if (!facturaId) return [];

        // Incercam mai multe rute posibile (foloseste prima care exista)
        // Pastreaza aici rutele tale reale daca sunt diferite.
        const candidates = [
          `/api/facturare/intrari/incarcaProduseIntrare/${facturaId}`,
          `/api/facturare/intrari/incarcaProduseFactura/${facturaId}`,
          `/api/facturare/intrari/produse/${facturaId}`,
        ];

        for (const url of candidates) {
          try {
            const resp = await axios.get(url);
            const data = resp && resp.data !== undefined ? resp.data : [];
            // unele endpoint-uri pot intoarce { produse: [...] }
            const arr = Array.isArray(data) ? data : (Array.isArray(data.produse) ? data.produse : (Array.isArray(data.items) ? data.items : []));
            if (Array.isArray(arr)) return arr;
          } catch (e) {
            // try next
          }
        }

        return [];
      },
      async hydrateEditFlow() {
        if (!this.isEditMode) return;
        const f0 = this.facturaEdit;
        if (!f0) return;

        const facturaId = f0.id || f0.id_factura || f0.id_document || null;

        // daca nu avem id, macar incercam sa hidratam header-ul
        if (!facturaId) {
          try { this.hydrateFacturaForEdit(f0); } catch (e) {}
          return;
        }

        if (this._hydratingEdit) return;
        this._hydratingEdit = true;

        try {
          // 1) hidratare rapida header (serie/nr/date/furnizor)
          this.hydrateFacturaForEdit(f0);

          // 2) incarcam produsele din backend (lista nu le trimite mereu)
          const produse = await this.fetchProduseIntrareForEdit(facturaId);

          // 3) re-hidratam cu produse atasate
          const f = { ...(f0 || {}) };
          f.id = facturaId;
          f.produse = produse;
          this.hydrateFacturaForEdit(f);
        } catch (e) {
          console.error('Eroare la hydrateEditFlow:', e);
        } finally {
          this._hydratingEdit = false;
        }
      },
      normalizeDateForInput(val) {
        if (!val) return '';
        const s = String(val).trim();
        if (!s) return '';

        // MySQL datetime: "YYYY-MM-DD HH:MM:SS"
        if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/.test(s)) return s.slice(0, 10);

        // ISO: "YYYY-MM-DDTHH:MM:SS..."
        if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10);

        // Already ok
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

        // Fallback parse
        const d = new Date(s);
        if (!Number.isNaN(d.getTime())) return d.toISOString().slice(0, 10);

        return '';
      },
      hydrateFacturaForEdit(src) {
        const f = src || this.facturaEdit;
        if (!f) return;

        // --- header
        this.factura.id = f.id || f.id_factura || this.factura.id || '';

        // seria/nr pot veni in mai multe chei (defensiv)
        // ListaFacturi.vue afiseaza de obicei {{ factura.serie_doc }}{{ factura.nr_doc }}
        this.factura.serie_document = (
          f.serie_doc ??
          ''
        )?.toString?.() ?? '';

        this.factura.nr_document = (
          f.nr_doc ??
          ''
        )?.toString?.() ?? '';



        // date pentru input[type=date]
        this.factura.data_emitere = this.normalizeDateForInput(f.data_emitere ?? f.data_doc ?? f.data ?? this.factura.data_emitere);
        this.factura.termen_plata = this.normalizeDateForInput(f.termen_plata ?? f.data_scadenta ?? f.scadenta ?? this.factura.termen_plata);

        // normalizare: inputurile nu primesc spatii / formate ciudate
        this.factura.serie_document = (this.factura.serie_document || '').toString().trim();
        this.factura.nr_document = (this.factura.nr_document || '').toString().trim();

        // alte campuri simple (daca exista)
        if (f.efactura !== undefined) this.factura.efactura = f.efactura;
        if (f.descarcare_gestiune !== undefined) this.factura.descarcare_gestiune = String(f.descarcare_gestiune);
        if (f.informatii_suplimentare !== undefined) this.factura.informatii_suplimentare = f.informatii_suplimentare || '';
        if (f.delegat_nume !== undefined) this.factura.delegat_nume = f.delegat_nume || '';
        if (f.delegat_date !== undefined) this.factura.delegat_date = f.delegat_date || '';
        if (f.delegat_auto !== undefined) this.factura.delegat_auto = f.delegat_auto || '';
        if (f.valuta !== undefined) this.factura.valuta = f.valuta;
        if (f.curs_valutar !== undefined) this.factura.curs_valutar = f.curs_valutar || '';
        if (f.intocmit_de !== undefined) this.factura.intocmit_de = f.intocmit_de || '';
        if (f.intocmit_cnp !== undefined) this.factura.intocmit_cnp = f.intocmit_cnp || '';

        // --- furnizor: preferam id + referinta din lista
        const furnId = f.furnizor ?? f.id_furnizor ?? (f.furnizor_obj ? f.furnizor_obj.id : null);
        if (furnId !== undefined && furnId !== null && furnId !== '') {
          const idNum = Number(furnId);
          const found = Array.isArray(this.lista_furnizori)
            ? this.lista_furnizori.find(x => Number(x.id) === idNum)
            : null;

          if (found) {
            this.factura.furnizor = idNum;
            this.factura.furnizor_obj = found;
            this.incarcaSoldFurnizorSelected(found);
          } else {
            // fallback: setam minim id-ul, iar obiectul ramane null pana se incarca lista
            this.factura.furnizor = idNum;
            this.factura.furnizor_obj = this.factura.furnizor_obj || null;
          }
        }

        // --- produse
        const produse = f.produse || f.detalii || f.linii || f.produse_factura || f.items || [];
        if (Array.isArray(produse) && produse.length) {
          this.facturaProduse = produse.map((p, idx) => {
            const tipId = p.tip != null ? Number(p.tip) : 1;
            const tipObj = Array.isArray(this.tip_produse)
              ? this.tip_produse.find(t => Number(t.id) === tipId)
              : null;

            const den = (p.denumire ?? p.text ?? p.produs ?? p.descriere ?? '')?.toString?.() ?? '';

            // UM poate veni ca id, text (ex: "BUC"), sau obiect
            const umResolved = this.resolveUmFromProdusRow(p);
            const umIdNum = umResolved.id;
            const umObj = umResolved.obj;

            return {
              pozitie: idx + 1,
              tip: String(tipId),
              tip_obj: tipObj || null,
              denumire: den,
              denumire_obj: den ? { id: null, text: den } : '',
              um: (umIdNum !== null ? umIdNum : ''),
              um_obj: umObj || null,
              cota_tva: Number(p.cota_tva ?? p.tva ?? 21),
              cantitate: p.cantitate ?? '',
              pret: p.pret ?? p.pret_unitar ?? '',
              valoare: p.valoare ?? '',
              valoare_tva: p.valoare_tva ?? p.tva_valoare ?? p.tva ?? '',
              total: p.total ?? '',
              cont_credit: p.cont_credit ?? p.cont ?? '',
              cont_credit_obj: this.plan_conturi.find(
                pc => pc.cod_complet === (p.cont_credit ?? p.cont)
              ) || null,
            };
          });

          this.$nextTick(() => {
            // sincronizam tip_obj pentru fiecare rand
            this.facturaProduse.forEach((produs) => {
              if (!produs.tip_obj && Array.isArray(this.tip_produse)) {
                produs.tip_obj = this.tip_produse.find(t => Number(t.id) === Number(produs.tip)) || null;
              }
              // --- UM: forteaza id numeric + obiectul EXACT din options (vue-multiselect)
              if (produs.um !== '' && produs.um !== null && produs.um !== undefined) {
                const n = Number(produs.um);
                produs.um = Number.isNaN(n) ? '' : n;
              }

              // daca um_obj lipseste, il rezolvam din lista
              if ((!produs.um_obj || !produs.um_obj.id) && produs.um && Array.isArray(this.unitati_masura)) {
                const found = this.unitati_masura.find(u => Number(u.id) === Number(produs.um)) || null;
                // folosim Vue.set ca sa fie reactiv daca cheia nu exista
                if (Object.prototype.hasOwnProperty.call(produs, 'um_obj')) {
                  produs.um_obj = found;
                } else {
                  produs.um_obj = found;
                }
              }

              // daca exista um_obj, il inlocuim cu referinta din options (obligatoriu pentru selectie)
              if (produs.um_obj && Array.isArray(this.unitati_masura)) {
                const ref = this.unitati_masura.find(u => Number(u.id) === Number(produs.um_obj.id)) || null;
                if (ref) produs.um_obj = ref;
              }

              // --- TVA: force numeric + object reference from options
              try {
                const tvaNum =
                  (produs.cota_tva !== '' && produs.cota_tva !== null && produs.cota_tva !== undefined)
                    ? Number(produs.cota_tva)
                    : null;

                if (tvaNum !== null && !Number.isNaN(tvaNum) && Array.isArray(this.cote_tva)) {
                  produs.cota_tva = tvaNum;
                  produs.cota_tva_obj = this.cote_tva.find(
                    ct => Number(ct.cota_tva) === tvaNum
                  ) || null;
                } else {
                  produs.cota_tva_obj = null;
                }
              } catch (e) {
                produs.cota_tva_obj = null;
              }
            });
            this.reindexPozitii();
            this.adaugaRandProdusDacaETGol();
          });
        }
      },
      async verificaCUI(cui) 
      {

        if (!cui) {
          this.$bvToast.toast('Introdu un CUI valid.', {
            title: 'Eroare',
            variant: 'danger',
            solid: true,
          });
          return;
        }

        try {
          const response = await axios.post('/api/efactura/verifica-cui/furnizor', { cui });

          const data = response.data;

          //if (data.status === 'exists') {
          //  this.$bvToast.toast('Furnizorul există deja în baza de date.', {
          //    title: 'Informație',
          //    variant: 'warning',
          //    solid: true,
          //  });
          //  return;
          //}

          if (response.data.status === 'exists' || response.data.status === 'preview') {
            const furnizor = response.data.client;

            // Autocomplete form
            this.form_modal_furnizori.f_denumire = furnizor.denumire || '';
            this.form_modal_furnizori.c_cui = furnizor.cui || '';
            this.form_modal_furnizori.c_reg_com = furnizor.reg_com || '';
            this.form_modal_furnizori.c_atrib_fiscal = furnizor.atrib_fiscal || '';
            this.form_modal_furnizori.c_scp_tva = furnizor.scp_tva || '';
            this.form_modal_furnizori.c_localitate = furnizor.localitate || '';
            this.form_modal_furnizori.c_strada = furnizor.strada || '';
            this.form_modal_furnizori.c_cod_postal = furnizor.cod_postal || '';
            this.form_modal_furnizori.c_adresa = furnizor.adresa || '';
            this.form_modal_furnizori.c_judet = furnizor.judet || '';
            this.form_modal_furnizori.c_tara = furnizor.tara || '';
            this.form_modal_furnizori.c_cont_banca = furnizor.cont_banca || '';
            this.form_modal_furnizori.c_telefon = furnizor.telefon || '';
            this.form_modal_furnizori.c_cut = furnizor.cut || '';

            toast.fire({
                  icon: 'success',
                  //title: 'Date preluate cu succes din ANAF.',
                  title: response.data.message || 'Furnizorul a fost găsit.',
            });
          } else {
            toast.fire({
                  icon: 'warning',
                  title: 'CUI-ul nu a fost găsit în ANAF.',
            });
          }
        } catch (error) {
          console.error(error);
          toast.fire({
                  icon: 'warning',
                  title: 'Eroare la verificarea CUI.'
          });
        }
      },
      adaugaProdusNou(newTag) {
        const newOption = { id: null, text: newTag };
        this.lista_produse.push(newOption);
        return newOption;
      },
      getUmObject(id) {
          const nid = (id === '' || id === null || id === undefined) ? null : Number(id);
          if (!Array.isArray(this.unitati_masura) || nid === null || Number.isNaN(nid)) return null;
          return this.unitati_masura.find(um => Number(um.id) === nid) || null;
      },
      resolveUmFromProdusRow(p) {
        const opts = Array.isArray(this.unitati_masura) ? this.unitati_masura : [];

        const umObjId = (p.um && typeof p.um === 'object')
          ? (p.um.id ?? p.um.um_id ?? p.um.value ?? null)
          : null;

        const umRaw = (
          umObjId ??
          p.um_id ??
          p.id_um ??
          p.id_um_masura ??
          p.um_masura_id ??
          p.unitate_masura ??
          p.unitate_masura_id ??
          p.um
        );

        // numeric id
        const asNum = (umRaw !== undefined && umRaw !== null && umRaw !== '' && !Number.isNaN(Number(umRaw)))
          ? Number(umRaw)
          : null;

        if (asNum !== null) {
          const obj = opts.find(u => Number(u.id) === Number(asNum)) || null;
          return { id: asNum, obj };
        }

        // text label (ex: "BUC")
        const asText = (umRaw ?? '').toString().trim();
        if (!asText) return { id: null, obj: null };

        const norm = asText.toLowerCase();
        const obj = opts.find(u => {
          const t = (u.text ?? '').toString().toLowerCase();
          const t0 = t.split(' (')[0];
          return t === norm || t0 === norm;
        }) || null;

        return { id: obj ? Number(obj.id) : null, obj };
      },
      adaugaRandProdusDacaETGol() {
          // Add a new row if the last row has real content, not just default tip, and only one empty row at the end is allowed.
          const produse = this.facturaProduse;
          if (produse.length === 0) return;

          // Helper: a row is empty if all fields except 'pozitie', 'tip', 'tip_obj' are blank/null/undefined
          function isRowEmpty(row) {
              return Object.entries(row).every(([key, val]) =>
                  key === 'pozitie' ||
                  key === 'tip' ||
                  key === 'tip_obj' ||
                  val === '' ||
                  val === null ||
                  val === undefined
              );
          }

          // Count how many empty rows are at the end
          let emptyRowsAtEnd = 0;
          for (let i = produse.length - 1; i >= 0; i--) {
              if (isRowEmpty(produse[i])) {
                  emptyRowsAtEnd++;
              } else {
                  break;
              }
          }

          // Get last row
          const last = produse[produse.length - 1];

          // Consider the row "filled" only if it has meaningful content (denumire or any numeric/value fields),
          // not just the default tip.
          const lastHasContent = !!(
              (last.denumire && String(last.denumire).trim() !== '') ||
              (last.cantitate && String(last.cantitate).trim() !== '') ||
              (last.pret && String(last.pret).trim() !== '') ||
              (last.valoare && String(last.valoare).trim() !== '') ||
              (last.total && String(last.total).trim() !== '') ||
              (last.cont_credit && String(last.cont_credit).trim() !== '')
          );

          // If the last row is filled and there isn't already an empty row at the end, add one
          if (lastHasContent && emptyRowsAtEnd === 0) {
              this.facturaProduse.push({
                  pozitie: produse.length + 1,
                  tip: '1',
                  tip_obj: this.tip_produse.find(t => t.id === 1),
                  denumire: '',
                  denumire_obj: '',
                  um: '',
                  um_obj: '',
                  cota_tva: (this.getDefaultCotaTVA().value !== null ? this.getDefaultCotaTVA().value : ''),
                  cota_tva_obj: (this.getDefaultCotaTVA().obj !== null ? this.getDefaultCotaTVA().obj : null),
                  cantitate: '',
                  pret: '',
                  valoare: '',
                  valoare_tva: '',
                  total: '',
                  cont_credit: '',
                  cont_credit_obj: null,
              });
              emptyRowsAtEnd = 1; // just added one
          }

          // Keep only one empty row at end (if more, remove extras)
          if (emptyRowsAtEnd > 1) {
              this.facturaProduse.splice(-1, emptyRowsAtEnd - 1);
          }
      },
      incarcaProduseSelect2(){
          axios.get('/api/facturare/utils/incarcaProduse')
          .then((response) => {
              this.lista_produse = response.data;
          });
      },
      onSelectValuta(valutaId) {
        const id = typeof valutaId === 'object' ? valutaId.id : valutaId;
        if (id && id !== '1') {
          this.incarcaValoareCursValutar(id);
        } else {
          this.factura.curs_valutar = 1;
        }
      },
      incarcaValute(){
          axios.get('/api/facturare/utils/iaValute')
          .then((response) => {
              this.valute = response.data;
          });
      },
      incarcaValoareCursValutar(id){
          axios.get('/api/facturare/utils/iaValute/'+id)
          .then((response) => {
              this.factura.curs_valutar = response.data;
          });
      },
      deschideNomenclatorProduseStoc() {
        // aici poți face ce vrei când se apasă pe buton
        console.log('Buton activat pentru:', );
      },
      async onSerieSelected(selected) {
        //console.log(selected.id)
        this.factura.serie_document = selected?.id;
        const serie = selected.id || selected.text || selected;
        try {
          const response = await axios.get(`/api/facturare/utils/incarcaNrFactura/${serie}`);
          const ultimNr = parseInt(response.data);
          this.factura.nr_document = ultimNr + 1;
        } catch (error) {
          console.error('Eroare la preluarea numărului document:', error);
        }
      },
      async incarcaSoldFurnizorSelected(selected) {
        const furnizor = selected.id || selected.text || selected;
        try {
          const response = await axios.get(`/api/facturare/utils/incarcaSoldFurnizor/${furnizor}`);
          this.factura.sold = response.data;
        } catch (error) {
          console.error('Eroare la incarcarea soldului firmei', error);
        }
      },
      reindexPozitii() {
        this.facturaProduse.forEach((p, i) => {
          p.pozitie = i + 1;
        });
      },
      resetProdusLine(index) {
        if (index === undefined || index === null) return;
        if (!Array.isArray(this.facturaProduse) || !this.facturaProduse[index]) return;

        const old = this.facturaProduse[index];
        const poz = old.pozitie || (index + 1);

        // pastreaza tip implicit (1) si tip_obj corect din lista
        const defaultTip = '1';
        const defaultTipObj = Array.isArray(this.tip_produse)
          ? (this.tip_produse.find(t => Number(t.id) === 1) || null)
          : null;

        const cleared = {
          pozitie: poz,
          tip: defaultTip,
          tip_obj: defaultTipObj,
          denumire: '',
          denumire_obj: '',
          um: '',
          um_obj: '',
          cota_tva: (this.getDefaultCotaTVA().value !== null ? this.getDefaultCotaTVA().value : ''),
          cota_tva_obj: (this.getDefaultCotaTVA().obj !== null ? this.getDefaultCotaTVA().obj : null),
          cantitate: '',
          pret: '',
          valoare: '',
          valoare_tva: '',
          total: '',
          cont_credit: '',
          cont_credit_obj: null,
        };

        // inlocuim obiectul ca sa se reseteze sigur multiselect-urile
        this.facturaProduse[index] = cleared;

        // Reindex + mentine regula cu un singur rand gol la final
        this.$nextTick(() => {
          this.reindexPozitii();
          this.adaugaRandProdusDacaETGol();
        });
      },
      updateCalcul(index, triggeredBy) {
        const p = this.facturaProduse[index];
        const qty = parseFloat(p.cantitate) || 0;
        const price = parseFloat(p.pret) || 0;
        const value = parseFloat(p.valoare) || 0;
        const tvaPercent = parseFloat(p.cota_tva) || 0;

        if (triggeredBy === 'cantitate' || triggeredBy === 'pret') {
          const newVal = qty * price;
          p.valoare = newVal.toFixed(2);
          p.valoare_tva = (newVal * tvaPercent / 100).toFixed(2);
          p.total = (newVal + (newVal * tvaPercent / 100)).toFixed(2);
        }

        if (triggeredBy === 'valoare') {
          const newPrice = qty > 0 ? value / qty : 0;
          p.pret = newPrice.toFixed(2);
          p.valoare_tva = (value * tvaPercent / 100).toFixed(2);
          p.total = (value + (value * tvaPercent / 100)).toFixed(2);
        }
      },
      updateFromTotal(index) {
        // Adaugat: recalculare cand totalul este modificat direct
        const produs = this.facturaProduse[index];

        const total = parseFloat(produs.total) || 0;
        const cantitate = parseFloat(produs.cantitate) || 1;
        const cota_tva = parseFloat(produs.cota_tva) || 0;

        const valoare_tva = total * (cota_tva / (100 + cota_tva));
        const valoare = total - valoare_tva;
        const pret = cantitate !== 0 ? valoare / cantitate : 0;

        produs.valoare = valoare.toFixed(2);
        produs.valoare_tva = valoare_tva.toFixed(2);
        produs.pret = pret.toFixed(2);
      },
      updateCalculProdus(index) {
        // Actualizare la modificarea oricarui camp relevant pentru produs (inclusiv total)
        const produs = this.facturaProduse[index];

        const cantitate = parseFloat(produs.cantitate) || 0;
        const pret = parseFloat(produs.pret) || 0;
        const cota_tva = parseFloat(produs.cota_tva) || 0;
        const valoare = cantitate * pret;
        const valoare_tva = valoare * (cota_tva / 100);
        const total = valoare + valoare_tva;

        produs.valoare = valoare.toFixed(2);
        produs.valoare_tva = valoare_tva.toFixed(2);
        produs.total = total.toFixed(2);
      },
      incarcaUnitatiMasura(){
          axios.get('/api/facturare/utils/incarcaUnitatiMasura')
          .then((response) => {
              this.unitati_masura = response.data;
              this.queueHydrateEdit();
          });
      },
      incarcaTipProduse(){
          axios.get('/api/facturare/utils/incarcaTipProduse')
          .then((response) => {
              this.tip_produse = response.data;
              this.facturaProduse.forEach(produs => {
                produs.tip_obj = this.tip_produse.find(t => t.id === Number(produs.tip)) || null;
              });
              this.queueHydrateEdit();
          });
      },
      handleFullArrowNavigation(event) {
          const selectors = '#formular input, #formular select, #formular textarea, #formular_rapid input, #formular_rapid select, #formular_rapid textarea';
          const inputs = Array.from(document.querySelectorAll(selectors)).filter(
              el => !el.disabled && el.offsetParent !== null
          );

          const index = inputs.indexOf(event.target);
          if (index === -1) return;

          // Detect .row-based layout for responsive facturaProduse
          const rowEl = event.target.closest('.row');
          let currentRowIndex = -1;
          let currentColIndex = -1;
          let rows = [];
          let usingRowLayout = false;

          if (rowEl) {
              // Find all sibling .row elements inside the same parent (the responsive container)
              rows = Array.from(rowEl.parentElement.querySelectorAll('.row')).filter(
                  row => row.querySelector('input, select, textarea')
              );
              for (let i = 0; i < rows.length; i++) {
                  const cols = Array.from(rows[i].querySelectorAll('input, select, textarea')).filter(
                      el => !el.disabled && el.offsetParent !== null
                  );
                  const colIndex = cols.indexOf(event.target);
                  if (colIndex !== -1) {
                      currentRowIndex = i;
                      currentColIndex = colIndex;
                      usingRowLayout = true;
                      break;
                  }
              }
          }

          // Fallback to table-based navigation if not in .row
          let table = null;
          let tableRows = [];
          let tableRowIdx = -1;
          let tableColIdx = -1;
          if (!usingRowLayout) {
              table = event.target.closest('table');
              if (table) {
                  tableRows = Array.from(table.querySelectorAll('tbody tr'));
                  for (let i = 0; i < tableRows.length; i++) {
                      const cols = Array.from(tableRows[i].querySelectorAll('input, select, textarea')).filter(
                          el => !el.disabled && el.offsetParent !== null
                      );
                      const colIndex = cols.indexOf(event.target);
                      if (colIndex !== -1) {
                          tableRowIdx = i;
                          tableColIdx = colIndex;
                          break;
                      }
                  }
              }
          }

          let next = null;
          const isNumberInput = event.target.tagName === 'INPUT' && event.target.type === 'number';
          switch (event.key) {
              case 'ArrowRight':
                  // Always move horizontally regardless of layout, even for number input
                  next = inputs[index + 1];
                  break;
              case 'ArrowLeft':
                  // Always move horizontally regardless of layout, even for number input
                  next = inputs[index - 1];
                  break;
              case 'ArrowDown':
              case 'ArrowUp':
                  if (isNumberInput) {
                      event.preventDefault();
                  }
                  // Responsive .row layout navigation
                  if (usingRowLayout && currentRowIndex !== -1 && currentColIndex !== -1) {
                      if (event.key === 'ArrowDown' && currentRowIndex < rows.length - 1) {
                          const nextRowInputs = Array.from(rows[currentRowIndex + 1].querySelectorAll('input, select, textarea')).filter(
                              el => !el.disabled && el.offsetParent !== null
                          );
                          next = nextRowInputs[currentColIndex] || null;
                      }
                      if (event.key === 'ArrowUp' && currentRowIndex > 0) {
                          const prevRowInputs = Array.from(rows[currentRowIndex - 1].querySelectorAll('input, select, textarea')).filter(
                              el => !el.disabled && el.offsetParent !== null
                          );
                          next = prevRowInputs[currentColIndex] || null;
                      }
                  }
                  // Table navigation fallback
                  if (!usingRowLayout && table && tableRowIdx !== -1 && tableColIdx !== -1) {
                      if (event.key === 'ArrowDown' && tableRowIdx < tableRows.length - 1) {
                          const nextRowInputs = Array.from(tableRows[tableRowIdx + 1].querySelectorAll('input, select, textarea')).filter(
                              el => !el.disabled && el.offsetParent !== null
                          );
                          next = nextRowInputs[tableColIdx] || null;
                      }
                      if (event.key === 'ArrowUp' && tableRowIdx > 0) {
                          const prevRowInputs = Array.from(tableRows[tableRowIdx - 1].querySelectorAll('input, select, textarea')).filter(
                              el => !el.disabled && el.offsetParent !== null
                          );
                          next = prevRowInputs[tableColIdx] || null;
                      }
                  }
                  break;
          }

          if (next) {
              event.preventDefault();
              next.focus();
          }
      },
      incarcaFurnizori(){
          axios.get('/api/facturare/utils/incarcaFurnizori')
          .then((response) => {
              this.lista_furnizori = (Array.isArray(response.data) ? response.data : []).map((x) => {
                const denumire = (x.text ?? x.denumire ?? x.nume ?? '').toString().trim();
                const cui = (x.cui ?? x.c_cui ?? x.cod_fiscal ?? x.cif ?? '').toString().trim();
                return {
                  ...x,
                  text: denumire || x.text,
                  cui: cui || x.cui,
                };
              });
              this.queueHydrateEdit();
          });
      },
      incarcaDetaliiFurnizori(){
          axios.get("/api/facturare/utils/furnizori")
          .then((response) => {
              this.detalii_furnizori = Array.isArray(response.data) ? response.data : [];

              this.$nextTick(() => {
                try { $('#tabel_furnizori').DataTable().destroy(); } catch (e) {}

                $('#tabel_furnizori').DataTable({
                  order: [[0, 'desc']],
                  dom: 'Bfrtip',
                  buttons: [],
                  language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                  },
                  paging: true,
                  ordering: true,
                  info: true,
                  searching: true,
                  responsive: true,
                  pageLength: 10,
                  retrieve: true,
                });
              });
          });
      },
      adaugaFurnizor(){
          this.$Progress.start();

          this.form_modal_furnizori.post('/api/facturare/utils/furnizori')
          .then((response) => {
              // ✅ Extragem ID-ul noului furnizor din mai multe forme posibile de răspuns
              const rd = (response && response.data !== undefined) ? response.data : null;

              // Unele endpoint-uri întorc direct ID-ul (ex: 54) în loc de obiect
              let id_nou = null;
              if (typeof rd === 'number') {
                id_nou = rd;
              } else if (typeof rd === 'string' && /^\d+$/.test(rd.trim())) {
                id_nou = Number(rd.trim());
              } else {
                const obj = (rd && typeof rd === 'object') ? rd : {};
                id_nou = obj.id ?? obj.furnizor_id ?? obj.id_furnizor ?? (obj.furnizor ? obj.furnizor.id : null) ?? (obj.data ? obj.data.id : null);
              }

              if (!id_nou) {
                console.error('Răspuns adăugare furnizor fără ID:', rd);
                toast.fire({ icon: 'warning', title: 'Furnizorul a fost adăugat, dar nu s-a primit ID-ul.' });
                this.$Progress.finish();
                return;
              }

              // Label/CUI: dacă backend-ul nu le întoarce, le luăm din form-ul modal
              const obj = (rd && typeof rd === 'object') ? rd : {};
              const nume_furnizor = (obj.denumire ?? obj.text ?? this.form_modal_furnizori.f_denumire ?? '').toString().trim();
              const cui_furnizor = (obj.cui ?? (obj.furnizor ? obj.furnizor.cui : null) ?? this.form_modal_furnizori.c_cui ?? '').toString().trim();

              const furnizor_obj_nou = {
                id: Number(id_nou),
                text: nume_furnizor,
                cui: cui_furnizor,
              };

              // IMPORTANT: vue-multiselect selectează cel mai sigur dacă obiectul este referință din lista de opțiuni.
              if (!Array.isArray(this.lista_furnizori)) this.lista_furnizori = [];

              // dacă există deja în listă, folosim referința existentă
              let furnizor_ref = this.lista_furnizori.find(x => Number(x.id) === Number(furnizor_obj_nou.id)) || null;

              if (!furnizor_ref) {
                this.lista_furnizori.unshift(furnizor_obj_nou);
                furnizor_ref = furnizor_obj_nou;
              } else {
                // menținem orice câmpuri existente și actualizăm label/cui
                furnizor_ref.text = furnizor_obj_nou.text;
                furnizor_ref.cui = furnizor_obj_nou.cui;
              }

              // ✅ Setăm furnizorul pe factură (id + obiect)
              this.factura.furnizor = Number(furnizor_ref.id);
              this.factura.furnizor_obj = furnizor_ref;

              toast.fire({
                icon: 'success',
                title: 'Furnizorul a fost adăugat și selectat cu succes.'
              });

              // curățăm form-ul din modal și închidem
              this.form_modal_furnizori.reset();
              this.showFormAdaugareFurnizor = false;
              $('#FurnizorModal').modal('hide');

              // refresh listă (async) - dar deja avem obiectul în listă pentru select
              try { $('#tabel_furnizori').DataTable().destroy(); } catch (e) {}
              this.incarcaFurnizori();

              if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
                try { emitter.emit('AfterCreate'); } catch (e) {}
              }

              this.$Progress.finish();
          })
          .catch((error) => {
              console.error('Eroare la adăugarea furnizorului:', error);
              this.$Progress.fail();
              toast.fire({
                icon: 'warning',
                title: 'Eroare la adăugarea furnizorului!'
              });
          })
      },
      actualizeazaFurnizor(id){
          this.$Progress.start();
          this.form_modal_furnizori.put('/api/facturare/utils/furnizori/'+id)
          .then(()=>{ //succes
              //$('#FurnizorModal').modal('hide');
              toast.fire({
                  icon: 'success',
                  title: 'Furnizor actualizat!'
              })
              this.form_modal_furnizori.reset();
              this.showFormAdaugareFurnizor = false;
              this.incarcaFurnizori();
              $('#tabel_furnizori').DataTable().destroy();
              this.incarcaDetaliiFurnizori();
              this.$Progress.finish();
          })
          .catch(()=>{//fail
              this.$Progress.fail();
              toast.fire({
                  icon: 'warning',
                  title: 'Eroare la actualizarea furnizorului!'
              })
          });
      },
      stergeFurnizor(furnizor) {
        Swal.fire({
          title: 'Ștergi furnizorul?',
          text: 'Această acțiune este ireversibilă!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Da, șterge',
          cancelButtonText: 'Anulează'
        }).then((result) => {
          if (!result.isConfirmed) return;

          this.$Progress.start();

          axios
            .delete('/api/facturare/utils/furnizori/'+furnizor)
            .then(() => {
              toast.fire({
                icon: 'success',
                title: 'Furnizor șters cu succes'
              });

              // refresh liste
              this.incarcaFurnizori();
              this.incarcaDetaliiFurnizori();

              // dacă era selectat în factură, îl golim
              if (this.factura.furnizor === furnizor) {
                this.factura.furnizor = '';
                this.factura.furnizor_obj = null;
                this.factura.sold = '';
              }

              this.$Progress.finish();
            })
            .catch((error) => {
              this.$Progress.fail();

              let mesaj = 'Eroare la ștergerea furnizorului.';

              if (error.response && error.response.data && error.response.data.message) {
                mesaj = error.response.data.message;
              }

              Swal.fire({
                icon: 'error',
                title: 'Nu se poate șterge furnizorul',
                text: mesaj,
              });
            });
        });
      },
      updateCalculations(prod) {
          const cant = parseFloat(prod.cantitate) || 0;
          const pret = parseFloat(prod.pret) || 0;
          const tva = parseFloat(prod.cota_tva) || 0;
          prod.valoare = +(cant * pret).toFixed(2);
          prod.valoare_tva = +((prod.valoare * tva) / 100).toFixed(2);
          prod.total = +(prod.valoare + prod.valoare_tva).toFixed(2);
      },
      incarcaSerii(){
          axios.get('/api/facturare/utils/incarcaSerii')
          .then((response) => {
              this.serii_facturi = response.data;
          });
      },
      adaugaFactura() {
          this.$Progress.start();
          // Filtrare produse fără denumire
          const produseFiltrate = Array.isArray(this.facturaProduse)
            ? this.facturaProduse.filter(p => p.denumire && p.denumire.trim() !== '')
            : [];

          if (produseFiltrate.length === 0) {
            toast.fire({
              icon: 'error',
              title: 'Factura nu are niciun produs valid.'
            });
            this.$Progress.fail();
            return;
          }

          // asigură-te că pentru facturi de intrare avem furnizor setat (id numeric)
          if (this.factura && this.factura.furnizor_obj && !this.factura.furnizor) {
            this.factura.furnizor = Number(this.factura.furnizor_obj.id || 0) || '';
          }

          // Defensive: ensure factura is a valid payload, use spread to avoid Form proxy issues
          const facturaPayload = this.factura ? { ...this.factura } : {};
          if (this.isEditMode && this.factura && this.factura.id) {
            facturaPayload.id = this.factura.id;
          }
          if (this.factura && this.factura.furnizor) facturaPayload.furnizor = Number(this.factura.furnizor) || this.factura.furnizor;
          const payload = {
            factura: facturaPayload,
            produse: produseFiltrate,
            id_proforma: this.id_proforma_selectata || null,
          };
          const facturaId = this.factura && this.factura.id ? this.factura.id : null;

          // CREATE vs EDIT
          const url = (this.isEditMode && facturaId)
            ? `/api/facturare/intrari/editeazaFacturaIntrare/${facturaId}`
            : '/api/facturare/intrari/adaugaFacturaIntrare';

          const req = (this.isEditMode && facturaId)
            ? axios.put(url, payload)
            : axios.post(url, payload);

          req
            .then((response) => {
              this.$Progress.finish();

              // dacă backend-ul a trimis status: "success", considerăm operațiunea reușită
              const data = response && response.data ? response.data : {};
              const fallbackMsg = this.isEditMode
                ? 'Factura de intrare a fost modificată cu succes.'
                : 'Factura de intrare a fost adăugată cu succes.';
              const msg = data.message || fallbackMsg;

              toast.fire({
                icon: 'success',
                title: msg,
                timer: undefined,
                showConfirmButton: false,
                showCloseButton: true,
              });

              // notificăm lista să se reîncarce și comutăm pe listă
              if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
                try {
                  emitter.emit('AfterCreate');
                } catch (err) {
                  console.error('Eroare în handler-ul AfterCreate:', err);
                }
              }
              if (this.isEditMode) {
                this.$emit('facturaSaved');
              }
              if (!this.isEditMode) {
                // opțional: resetăm doar minim datele locale, fără apeluri suplimentare care pot arunca eroare
                this.facturaProduse = [
                  {
                    pozitie: 1,
                    tip: '1',
                    denumire: '',
                    um: '',
                    cota_tva: 19,
                    cantitate: '',
                    pret: '',
                    valoare: '',
                    valoare_tva: '',
                    total: '',
                    cont_credit: '',
                  }
                ];
              }
            })
            .catch((error) => {
              let mesaj = 'Eroare la salvarea facturii.';
              if (error && error.response && error.response.data) {
                if (error.response.data.message) {
                  mesaj = error.response.data.message;
                }
                if (error.response.data.errors) {
                  const detalii = Object.values(error.response.data.errors)
                    .map(err => `• ${err}`)
                    .join('<br>');
                  mesaj += '<br><br>' + detalii;
                }
              } else if (error && error.message) {
                mesaj = error.message;
              }

              toast.fire({
                icon: 'error',
                title: mesaj,
                timer: undefined,
                showConfirmButton: false,
                showCloseButton: true,
              });
              console.error('Eroare la salvarea facturii (axios):', error);
              this.$Progress.fail();
            });
      },
      editareFurnizorFormFill(furnizor){
          this.form_modal_furnizori.reset();
          this.form_modal_furnizori.fill(furnizor);
          this.showFormAdaugareFurnizor = true;
          this.editmode = true;
      },
      modalNomenclatorFurnizori(){
          this.editmode = false;
          this.form_modal_furnizori.reset();
          this.incarcaDetaliiFurnizori();
          $('#FurnizorModal').modal('show');
      },
      deschideFormAdaugareFurnizor(searchTerm) {
        this.modalNomenclatorFurnizori();

        this.$nextTick(() => {
          this.showFormAdaugareFurnizor = true;

          if (!this.form_modal_furnizori) return;

          const term = (searchTerm || '').trim();

          // 🔎 dacă este CUI (doar cifre)
          if (/^\d+$/.test(term)) {
            this.form_modal_furnizori.c_cui = term;
            this.form_modal_furnizori.f_denumire = '';
          } else {
            // 🏷️ altfel, presupunem denumire
            this.form_modal_furnizori.f_denumire = term;
            this.form_modal_furnizori.c_cui = '';
          }
        });
      },
      furnizorLabel(option) {
        if (!option) return '';

        // backend can return either { id, text, cui } or other keys
        const denumire = (option.text ?? option.denumire ?? option.nume ?? '').toString().trim();
        const cui = (option.cui ?? option.c_cui ?? option.cod_fiscal ?? option.cif ?? '').toString().trim();

        return cui ? `${denumire} (${cui})` : denumire;
      },
      deschideModalFP() {
        this.incarcaProforme();
        $('#ModalProforme').modal('show');
      },
      incarcaProforme() {
        axios.get('/api/facturare/utils/incarcaDateFP')
          .then((response) => {
            this.proforme = Array.isArray(response.data) ? response.data : [];
          })
          .catch((error) => {
            console.error('Eroare la încărcarea proformelor:', error);
            this.proforme = [];
          });
      },
      selecteazaProforma(pf) {
        if (!pf || !pf.id) return;
        // UI loading doar pentru acest rând
        if (this.$set) this.$set(pf, '_loading', true); else pf._loading = true;

        axios.get(`/api/facturare_proforme/utils/detalii/${pf.id}`)
          .then(({ data }) => {
            const { f, date, produse } = data || {};

            // 1) Furnizor (nu schimbăm seria/numărul din formularul de factură)
            if (f && f.id_furnizor) {
              const cli = this.lista_furnizori.find(c => Number(c.id) === Number(f.id_furnizor));
              if (cli) {
                this.factura.furnizor_obj = cli;
                this.factura.furnizor = cli.id;
                this.incarcaSoldFurnizorSelected(cli);
              }
            }

            // 2) Info suplimentare (NU modificăm datele și seria/numărul!)
            if (f && typeof f.informatii_suplimentare === 'string') {
              this.factura.informatii_suplimentare = f.informatii_suplimentare;
            }

            // 3) Produse din proformă -> mapare pe structura formularului de factură
        if (Array.isArray(produse) && produse.length) {
          this.facturaProduse = produse.map((p, idx) => {
            const tipId = p.tip != null ? Number(p.tip) : 1;
            const tipObj = this.tip_produse.find(t => Number(t.id) === tipId) || null;
            // UM poate veni ca id numeric sau ca text (ex: "buc", "ore") sau chiar ca string numeric ("1"). Încercăm toate variantele întâlnite în proforme.
            const umResolved = this.resolveUmFromProdusRow(p);
            const umIdNum = umResolved.id;
            const umObj = umResolved.obj;

            const cant = p.cantitate != null ? p.cantitate : '';
            const pret = p.pret_unitar != null ? p.pret_unitar : '';
            const cota = p.cota_tva != null ? p.cota_tva : 19;
            const val  = p.valoare != null ? p.valoare : '';
            const tva  = p.tva != null ? p.tva : '';
            const tot  = p.total != null ? p.total : '';

            return {
              pozitie: idx + 1,
              tip: String(tipId),
              tip_obj: tipObj,
              denumire: p.denumire || '',
              denumire_obj: p.denumire ? { id: null, text: p.denumire } : null,
              um: (umIdNum !== null ? umIdNum : ''),
              um_obj: umObj,
              cota_tva: Number(cota),
              cantitate: cant,
              pret: pret,
              valoare: val,
              valoare_tva: tva,
              total: tot,
              cont_credit: p.cont_credit || ''
            };
          });

          // recalculări de siguranță (dacă lipsesc câmpuri)
          this.facturaProduse.forEach((prod, i) => this.updateCalculations(this.facturaProduse[i]));
        }

            // Setează id_proforma_selectata înainte de închiderea modalului
            this.id_proforma_selectata = pf.id;
            // 4) Închide modalul și anunță utilizatorul
            $('#ModalProforme').modal('hide');
            toast.fire({ icon: 'success', title: 'Proforma a fost preluată în formular.' });
          })
          .catch((err) => {
            console.error('Eroare la preluarea proformei:', err);
            toast.fire({ icon: 'error', title: 'Eroare la preluarea proformei.' });
          })
          .finally(() => {
            if (this.$set) this.$set(pf, '_loading', false); else pf._loading = false;
          });
      },
      async creeazaFacturaInstant(pf) {
        if (!pf || !pf.id) return;
        if (this.$set) this.$set(pf, '_creating', true); else pf._creating = true;

        try {
          const confirm = await Swal.fire({
            title: 'Creezi factura direct?',
            html: `
              <p>Această acțiune va genera factura imediat, fără editare.</p>
              <p style="color: red; font-weight: bold;">Aceasta va folosi ultima plajă de serii folosită!</p>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, creează',
            cancelButtonText: 'Anulează'
          });

          if (!confirm.isConfirmed) return;

          const response = await axios.post('/api/facturare/creeazaDinProforma', { id_proforma: pf.id });
          toast.fire({
            icon: 'success',
            title: `Factura #${response.data.nr_doc} a fost creată cu succes!`
          });

          // Scoatem proforma din listă, pentru că acum e facturată
          this.proforme = this.proforme.filter(p => p.id !== pf.id);
          // Notifică lista de facturi să se reîncarce și comută pe listă
          if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
            try {
              emitter.emit('AfterCreate');
            } catch (err) {
              console.error('Eroare în handler-ul AfterCreate:', err);
            }
          }
          this.$emit('update:afiseazaLista', true);

        } catch (error) {
          console.error('Eroare la crearea facturii instant:', error);
          toast.fire({
            icon: 'error',
            title: 'Eroare la crearea facturii instant.'
          });
        } finally {
          if (this.$set) this.$set(pf, '_creating', false); else pf._creating = false;
        }
      },
      mapUmFromAny(p) {
        if (!p) return null;
        if (!Array.isArray(this.unitati_masura) || this.unitati_masura.length === 0) return null;

        const umIdRaw = (p.um_id !== undefined ? p.um_id : (p.id_um !== undefined ? p.id_um : (p.um !== undefined ? p.um : null)));
        const umTextRaw = (p.um_text || p.unitate_masura || p.um_denumire || (typeof p.um === 'string' ? p.um : ''));
        const umLower = String(umTextRaw || '').trim().toLowerCase();

        if (umIdRaw !== undefined && umIdRaw !== null && umIdRaw !== '' && !isNaN(Number(umIdRaw))) {
          const found = this.unitati_masura.find(u => Number(u.id) === Number(umIdRaw));
          if (found) return found;
        }

        if (umTextRaw !== undefined && umTextRaw !== null && String(umTextRaw).trim() !== '' && /^\d+$/.test(String(umTextRaw).trim())) {
          const n = Number(String(umTextRaw).trim());
          const found = this.unitati_masura.find(u => Number(u.id) === n);
          if (found) return found;
        }

        if (umLower) {
          return this.unitati_masura.find(u => (u.text || '').toLowerCase() === umLower)
            || this.unitati_masura.find(u => ((u.text || '').split(' (')[0] || '').toLowerCase() === umLower)
            || null;
        }

        return null;
      },
      normalizeDateForInput(val) {
        if (!val) return '';
        const s = String(val).trim();
        if (!s) return '';

        // MySQL datetime: "YYYY-MM-DD HH:MM:SS"
        if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/.test(s)) return s.slice(0, 10);

        // ISO: "YYYY-MM-DDTHH:MM:SS..."
        if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10);

        // Already ok
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

        // Fallback
        const d = new Date(s);
        if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);

        return '';
      },
        
    },
    watch: {
      facturaEdit: {
        handler(v) {
          if (this.editMode && v) {
            this.hydrateFacturaForEdit(v);
          }
        },
        immediate: true,
        deep: false,
      },
      editMode: {
        handler(v) {
          if (v && this.facturaEdit) {
            this.hydrateFacturaForEdit(this.facturaEdit);
          }
        },
        immediate: true,
        deep: false,
      },
      // dupa ce se incarca lista furnizorilor, daca avem doar id setat, refacem obiectul pentru multiselect
      lista_furnizori: {
        handler() {
          if (this.editMode && this.factura && this.factura.furnizor && !this.factura.furnizor_obj && Array.isArray(this.lista_furnizori)) {
            const found = this.lista_furnizori.find(x => Number(x.id) === Number(this.factura.furnizor));
            if (found) {
              this.factura.furnizor_obj = found;
              this.incarcaSoldFurnizorSelected(found);
            }
          }
        },
        deep: false,
      },
      cote_tva() {
        this.queueHydrateEdit();
      }
    },
    mounted() {
      
    },
    
    computed: {
        modelAfiseazaLista: {
            get() {
                return this.afiseazaLista;
            },
            set(value) {
                this.$emit('update:afiseazaLista', value);
            }
        },
        isEditMode() {
          return !!this.editMode;
        }
    },
    watch: {
      facturaProduse: {
        handler(newVal, oldVal) {
          // Watch pentru fiecare produs, daca totalul se schimba manual, actualizeaza pret/valoare/valoare_tva
          newVal.forEach((produs, index) => {
            if (
              oldVal &&
              oldVal[index] &&
              produs.total !== oldVal[index].total
              && produs.total !== ""
            ) {
              this.updateFromTotal(index);
            }
          });
        },
        deep: true
      },
      facturaEdit: {
        immediate: true,
        handler(val) {
          if (!val) return;
          this.hydrateFacturaForEdit(val);
        }
      },
      lista_furnizori() {
        if (this.isEditMode && this.facturaEdit && (!this.factura.furnizor || !this.factura.furnizor_obj)) {
          this.hydrateFacturaForEdit(this.facturaEdit);
        }
      },
      tip_produse() {
        if (this.isEditMode && this.facturaEdit) this.hydrateFacturaForEdit(this.facturaEdit);
      },
      unitati_masura() {
        if (this.isEditMode && this.facturaEdit) this.hydrateFacturaForEdit(this.facturaEdit);
      }
    },
    created(){
        emitter.on('searching',() => {//search
            let query = this.$parent.search;
            axios.get('/api/utile/cautareDosare?cD=' + query)
            .then((data)=>{
                this.dosare =data.data
            })
            .catch(()=>{
                console.log('eroare la cautare');
            })
        })
        emitter.on('AfterCreate',() => { 

        });
        this.incarcaFurnizori();
        this.incarcaSerii();
        this.incarcaUnitatiMasura();
        this.incarcaTipProduse();
        this.incarcaProduseSelect2();
        this.incarcaValute();
        this.incarcaPC();
        this.incarcaCoteTVA();
    },
    
    }
    </script>
    
<style lang="scss" scoped>
/* =====================
   Tables / Modals
   ===================== */
table {
  table-layout: fixed;
  width: 100%;
}

.icon-mare {
  font-size: 24px;
}

.modal {
  z-index: 9003;
}

#tabel_furnizori {
  border-collapse: collapse;
  border-spacing: 0;
}
#tabel_furnizori th,
#tabel_furnizori td {
  padding: 2px 2px;
  border: 1px solid #ccc;
  font-size: 13px;
  vertical-align: middle;
}

/* =====================
   Select2 fixes
   ===================== */
.select2-fix {
  width: 100% !important;
  display: block;
  min-width: 0 !important;
  flex-shrink: 1 !important;
  overflow: hidden !important;
}

.select2-fix .select2-container {
  width: 280px !important;
  min-width: 280px !important;
  max-width: 280px !important;
}

.select2-fix .select2-selection {
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  border-radius: 4px;
}

.select2-fix .select2-selection__rendered {
  display: block !important;
  width: 100% !important;
  padding-right: 10px;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

/* =====================
   Vue-Multiselect
   ===================== */
/* Keep parent containers from clipping dropdowns */
.row,
.table-responsive,
.col-auto,
.template {
  overflow: visible !important;
  position: relative;
}

/* Base sizing to match Bootstrap form-control */
:deep(.multiselect),
:deep(.multiselect__single),
:deep(.multiselect__single span),
:deep(.multiselect__input),
:deep(.multiselect__placeholder),
:deep(.multiselect__option),
:deep(.multiselect__content-wrapper) {
  font-size: 1rem !important;
}

:deep(.multiselect) {
  min-height: 38px;
  padding: 0;
}

/* Align selected value like a normal input */
:deep(.multiselect__single) {
  line-height: 1.5;
  padding: 0.375rem 0.5rem;
}

/* Compact dropdown options */
:deep(.multiselect__option) {
  padding: 6px 8px;
}

/* Prevent font jump when focused/typing */
:deep(.multiselect--active),
:deep(.multiselect--active .multiselect__input),
:deep(.multiselect--active .multiselect__single),
:deep(.multiselect--active .multiselect__single span),
:deep(.multiselect--active .multiselect__placeholder),
:deep(.multiselect--active .multiselect__option),
:deep(.multiselect__input:focus) {
  font-size: 0.875rem !important;
}

/* Dropdown layer: stay above tables/modals */
:deep(.multiselect__content-wrapper) {
  z-index: 999999 !important;
  position: absolute !important;
  top: 100% !important;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 1px solid var(--bs-border-color, #e4e6ef) !important;
}

:deep(.multiselect__content) {
  background: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 0;
}

:deep(.multiselect__tags),
:deep(.multiselect__input),
:deep(.multiselect__single),
:deep(.multiselect__placeholder) {
  color: var(--bs-body-color) !important;
  background-color: var(--bs-body-bg) !important;
}

:deep(.multiselect__tags input.multiselect__input) {
  color: var(--bs-body-color) !important;
  caret-color: var(--bs-primary, #3e97ff) !important;
}

/* Highlight vs selected (avoid “double selected” look) */
:deep(.multiselect__option--selected) {
  background: rgba(var(--bs-primary-rgb), 0.12) !important;
  color: inherit !important;
}

:deep(.multiselect__option--highlight) {
  background: var(--bs-primary, #3e97ff) !important;
  color: var(--bs-primary-inverse, #fff) !important;
}

:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: var(--bs-primary, #3e97ff) !important;
  color: var(--bs-primary-inverse, #fff) !important;
}

/* Per-field tweaks */
.furnizor-multiselect :deep(.multiselect__single) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tip-produse-multiselect {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tip-col {
  min-width: 0 !important;
}
.tip-produse-multiselect :deep(.multiselect__single) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

.denumire-col {
  min-width: 0 !important;
}
.multiselect-denumire {
  overflow: visible !important;
  position: relative !important;
  z-index: 999;
}
.multiselect-denumire :deep(.multiselect__single),
.multiselect-custom :deep(.multiselect__single) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

/* Denumire dropdown: may need wider panel */
.multiselect-denumire :deep(.multiselect__content-wrapper) {
  width: max-content;
  min-width: 100%;
  max-height: 250px;
  left: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Plan conturi multiselect (Cont credit) */
.ms-pc :deep(.multiselect__option) {
  padding: 4px 8px;
  font-size: 12px !important;
  line-height: 1.05;
  white-space: nowrap;
}

.ms-pc :deep(.pc-opt) {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ms-pc :deep(.pc-cod) {
  font-weight: 600;
  flex: 0 0 auto;
}

.ms-pc :deep(.pc-sep) {
  opacity: 0.55;
  flex: 0 0 auto;
}

.ms-pc :deep(.pc-den) {
  flex: 0 0 auto;
}

/* Dark theme fine-tune */
[data-bs-theme="dark"] :deep(.multiselect__tags),
[data-bs-theme="dark"] :deep(.multiselect__input),
[data-bs-theme="dark"] :deep(.multiselect__single),
[data-bs-theme="dark"] :deep(.multiselect__placeholder) {
  background-color: #1e1e2d !important;
  color: #e1e3ea !important;
}
[data-bs-theme="dark"] :deep(.multiselect__content-wrapper),
[data-bs-theme="dark"] :deep(.multiselect__content) {
  background-color: #1e1e2d !important;
  border-color: #2b2b40 !important;
}

/* =====================
   Modal Proforme
   ===================== */
#ModalProforme .modal-dialog {
  max-width: 900px !important;
  margin: 1.25rem auto !important;
}
#ModalProforme .modal-content {
  overflow: hidden;
}
#ModalProforme .modal-body {
  overflow: hidden;
}
#ModalProforme .table-responsive {
  overflow-x: auto;
}
#ModalProforme .table {
  table-layout: fixed;
  width: 100%;
}
#ModalProforme .table th,
#ModalProforme .table td {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: middle;
}
#ModalProforme td.actions {
  white-space: nowrap;
}
#ModalProforme td.actions.d-flex {
  flex-wrap: wrap;
}
#ModalProforme td.actions .btn {
  white-space: nowrap;
}

/* === TVA multiselect: show full value (21%) === */
:deep(.multiselect-custom[style*="80px"] .multiselect__single) {
  white-space: nowrap;
  overflow: visible !important;
  text-overflow: clip !important;
  padding-left: 6px;
  padding-right: 6px;
}

:deep(.multiselect-custom[style*="80px"] .multiselect__input) {
  white-space: nowrap;
  overflow: visible !important;
}

:deep(.tip-produse-multiselect .tp-opt){
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
:deep(.tip-produse-multiselect .tp-abbr){
  font-weight: 600;
  flex: 0 0 auto;
}
:deep(.tip-produse-multiselect .tp-sep){
  opacity: .55;
  flex: 0 0 auto;
}
:deep(.tip-produse-multiselect .tp-text){
  flex: 0 0 auto;
}

/* TIP: mic când e închis, dar dropdown mare */
:deep(.tip-produse-multiselect) {
  width: 80px;
}

/* dropdown-ul rămâne lat, indiferent cât de mic e câmpul */
:deep(.tip-produse-multiselect .multiselect__content-wrapper) {
  min-width: 260px;
  width: max-content;
  max-width: 520px;
}
</style>
